export default "__VITE_ASSET__CaRX8EQ1__"